module.exports = __webpack_public_path__ + "./images/rocket.svg?95ada4574ecc5f91fa5a8ca7795e9bbb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/rocket.svg
// module id = 86
// module chunks = 0